import { render, staticRenderFns } from "./ReferralModal.vue?vue&type=template&id=b933a87e"
import script from "./ReferralModal.vue?vue&type=script&lang=js"
export * from "./ReferralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports